import * as Sentry from '@sentry/react'
import { ErrorRecovery } from '@/components/shared/ErrorRecovery'

interface Props {
  children: React.ReactNode
}

export function SentryErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError, eventId }) => (
        <ErrorRecovery
          errorId={eventId}
          onRetry={resetError}
          onReport={() => Sentry.showReportDialog({ eventId })}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
